import { LibConfig } from "../../init";
import { START_PAGINATION } from "../../constants";
export const getLeaguesRequest = () => {
    return {
        ids: LibConfig.sportIds,
        regionIds: LibConfig.regionIds,
        pagination: START_PAGINATION,
        includeRegions: true
    };
};
//# sourceMappingURL=getLeaguesRequest.js.map